import React from 'react';

import {Skeleton} from '@albert-io/atomic';

// Mirrors the loaded banner's layout and height (name on the left, Invite control on the right; the
// 44px control sets the row height to match), so it swaps in place with no shift or white flash
// while the class loads.
export const ClassHeaderSkeleton = () => (
  <div aria-busy='true' className='shrink-0'>
    <header className='background-subtle gap-x2 px-x4 py-x6 flex min-h-[92px] items-center'>
      <Skeleton className='h-x3 max-w-[240px] grow rounded-full' />
      <Skeleton className='w-x13 h-[44px] shrink-0 rounded-full' />
      <span className='sr-only' role='status'>
        Loading class…
      </span>
    </header>
  </div>
);

/** Generic body placeholder shared by every class tab while the class loads. */
export const ClassDetailContentSkeleton = () => (
  <div aria-busy='true' className='gap-x3 pt-x4 flex flex-col'>
    <span className='sr-only' role='status'>
      Loading…
    </span>
    <Skeleton className='h-x4 w-[200px] rounded-full' />
    <div aria-hidden='true' className='gap-x2 flex flex-col'>
      {['r1', 'r2', 'r3', 'r4', 'r5', 'r6'].map((key) => (
        <Skeleton className='h-x8 rounded-x1 w-full' key={key} />
      ))}
    </div>
  </div>
);
